'use strict'

/**
 * MODULE ADRESSE INSCRIPTION
 */

import ajaxLoader from 'Modules/ajaxLoader'
import urlModule from 'Modules/url'

const J_COMPLEMENT_ADRESSE_LINK = '.j_inscriptionProcess_complementAdressClick'
const J_COMPLEMENT_ADRESSE = '.j_inscriptionProcess_complementAdresse'
const J_CODE_POSTAL = '.j_inscriptionProcess_codePostal'
const J_CODE_POSTAL_NAME = 'cp'
const J_CODE_POSTAL_ACTION = 'action'
const J_DIV_ERROR_CODE_POSTAL = '.j_inscriptionProcess_codePostalError'
const J_VILLE_SELECTOR = '.j_inscriptionProcess_villeSelector'
const J_CLASSICAL_VILLE_INPUT = '.j_inscriptionProcess_villeInput'
const C_HIDDEN = 'hidden'
const J_SOURCE_AJAX_DATA = 'source'
const J_DATA_VALUE_PAYS = 'value'
const J_VILLE_ERROR = '.j_inscriptionProcess_villeError'
const J_AUTRES_PAYS_LINK = '.j_inscriptionProcess_autresPays'
const J_AUTRES_PAYS_SELECT = '.j_select_autresPays'
const J_LABEL_PAYS_TO_HIDE = '.j_inscriptionProcess_PaysToHide'
const J_VILLE_NAME = 'ville'
const J_INSCRIPTION_ERROR = '.j_inscription_error'
const J_MODIFIER_ADRESSE_LIVRAISON_BUTTON = '.j_submit_modifierAdresseLivraison'
const J_MODIFIER_ADRESSE_FACTURATION_BUTTON =
    '.j_submit_modifierAdresseFacturation'
const J_DATA_ACTION_MODIFICATION_ADRESSE_LIVRAISON = 'action'
const J_DATA_ACTION_MODIFICATION_ADRESSE_FACTURATION = 'actionfacturation'
const J_TELEPHONE = '.j_telephone'
const J_LAST_TELEPHONE_NAME = 'telephonePart5'
const J_OTHER_TELEPHONE = '.j_otherPaysTelephone'
const J_AUTRES_VILLES = 'j_autres_villes'
const J_CHANGE_ADDRESS_POPUP = '.j_modal_change_address'

const J_CODE_POSTAL_SELECTOR = '.j_code_postal_select'
const J_LINE_ADRESSE_SELECTOR = '.j_line_adresse_select'
const J_COMPLEMENT_ADRESSE_SELECTOR = '.j_complement_adresse_select'
const J_VILLE_NAME_SELECTOR = '.j_ville_name_select'
const J_NAME_SELECTOR = '.j_name_select'

/*
 * Fonction de validation du formulaire et d'appel du process d'inscription en ajax
 * pour modification d'adresse inscription en popup
 */
function processModificationAdresseLivraison(event) {
    const $form = $(event.target)
    const button = $form
        .find(J_MODIFIER_ADRESSE_LIVRAISON_BUTTON + ':submit')
        .not(':hidden')
    const action = $(button).data(J_DATA_ACTION_MODIFICATION_ADRESSE_LIVRAISON)

    const parameters = $form
        .find(':input')
        .not(J_AUTRES_PAYS_SELECT)
        .serializeArray()
    const $pays = $(J_AUTRES_PAYS_SELECT)

    if ($pays.val() == '') {
        return false
    }

    parameters.push({
        name: $pays.attr('name'),
        value: $($pays.find(':selected')).data(J_DATA_VALUE_PAYS)
    })

    ajaxLoader.loadAndExecuteCallBack(
        'POST',
        parameters,
        function (content) {
            if (content.Result === false) {
                $(J_INSCRIPTION_ERROR).removeClass(C_HIDDEN)
                $(J_INSCRIPTION_ERROR).empty().append(content.Message)
            } else {
                $(J_LINE_ADRESSE_SELECTOR).empty().append(content.LigneAdresse)
                if (content.ComplementLigneAdresse != null) {
                    $(J_COMPLEMENT_ADRESSE_SELECTOR)
                        .empty()
                        .append(content.ComplementLigneAdresse)
                }
                $(J_CODE_POSTAL_SELECTOR + J_VILLE_NAME_SELECTOR)
                    .empty()
                    .append(content.CodePostal + ' - ' + content.Ville)
                $(J_NAME_SELECTOR)
                    .empty()
                    .append(content.Prenom + ' ' + content.Nom)

                const redirectionUrl = urlModule.parseRedirectionParameter()

                if (redirectionUrl !== undefined && redirectionUrl !== '') {
                    parent.location.href = redirectionUrl
                } else {
                    // close popup
                    $(J_CHANGE_ADDRESS_POPUP).modal('hide')
                }

                if (content.Reload === true) {
                    window.location.reload(true)
                }
            }
        },
        function () {
            // En cas d'échec on affiche une erreur
        },
        action
    )

    return false
}

function processModificationAdresseFacturation(event) {
    const $form = $(event.target)
    const button = $form
        .find(J_MODIFIER_ADRESSE_FACTURATION_BUTTON + ':submit')
        .not(':hidden')
    const action = $(button).data(
        J_DATA_ACTION_MODIFICATION_ADRESSE_FACTURATION
    )
    const parameters = $form
        .find(':input')
        .not(':hidden')
        .not(J_AUTRES_PAYS_SELECT)
        .serializeArray()
    const $pays = $(J_AUTRES_PAYS_SELECT)

    parameters.push({
        name: $pays.attr('name'),
        value: $($pays.find(':selected')).data(J_DATA_VALUE_PAYS)
    })

    ajaxLoader.loadAndExecuteCallBack(
        'POST',
        parameters,
        function (content) {
            if (content.Result === false) {
                $(J_INSCRIPTION_ERROR).removeClass(C_HIDDEN)
                $(J_INSCRIPTION_ERROR).empty().append(content.Message)
            } else {
                const redirectionUrl = urlModule.parseRedirectionParameter()

                if (redirectionUrl !== undefined && redirectionUrl !== '') {
                    parent.location.href = redirectionUrl
                }
            }
        },
        function () {
            // En cas d'échec on affiche une erreur
        },
        action
    )

    return false
}

/*
 * Fonction d'apparition du champ complément d'adresse au clique
 */
function setEventOnComplementAdresseLink() {
    $(J_COMPLEMENT_ADRESSE_LINK).on('click', function (event) {
        $(J_COMPLEMENT_ADRESSE).removeClass(C_HIDDEN)
        $(event.currentTarget).addClass(C_HIDDEN)
        return false
    })
}

/*
 * Fonction d'affichage des villes à partir du CP rentré par l'utilisateur
 */
function setEventForGettingVillesByCodePostal() {
    $(J_CODE_POSTAL).on('change paste keyup', function (event) {
        // on execute sur les events de modidification de la value du champ
        // $(J_AUTRES_PAYS_SELECT + ' option[data-value=FR]').remove();
        $(J_AUTRES_PAYS_SELECT).removeClass(C_HIDDEN)
        $(J_LABEL_PAYS_TO_HIDE).addClass(C_HIDDEN)

        if (event.preventDefault) {
            event.preventDefault()
        } else {
            event.returnValue = false
        }

        if (
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'FR' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'GF' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'GP' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'MQ' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'MU' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') !=
                'PM' &&
            $(J_AUTRES_PAYS_SELECT + ' option:selected').data('value') != 'RE'
        ) {
            // On ne fais pas le chargement de la liste si ce n'est pas nécessaire
            return
        }

        const form = $(event.currentTarget).closest('form')

        import('Modules/bootstrapValidationForm').then(
            (bootstrapValidationForm) => {
                bootstrapValidationForm.default.validateField(
                    '#' + $(form).attr('id'),
                    $(event.currentTarget).attr('name')
                ) // On dois valider le field si on veut que le isValidField fonctionne

                if (
                    bootstrapValidationForm.default.isValidField(
                        '#' + $(form).attr('id'),
                        $(event.currentTarget).attr('name')
                    ) === true
                ) {
                    const action = $(event.currentTarget).data(
                        J_CODE_POSTAL_ACTION
                    )
                    const parameters = {
                        cp: $(event.currentTarget).val()
                    }

                    ajaxLoader.loadAndExecuteCallBack(
                        'POST',
                        parameters,
                        function (content) {
                            const select = $(J_VILLE_SELECTOR)

                            if (content.ListVilles.length > 0) {
                                const selectElement = select[0]

                                // On supprime tout les 'options' pour nettoyer la liste pour les nouvelles valeurs
                                for (const a in selectElement.options) {
                                    selectElement.options.remove(a)
                                }

                                // On ajout l'élément par défaut
                                const opt = document.createElement('option')
                                opt.value = ''
                                opt.innerHTML = $t('SELECTIONNEZ_VILLE')
                                select[0].appendChild(opt)

                                // On ajoute le résultat de la requête
                                for (
                                    let i = 0;
                                    i < content.ListVilles.length;
                                    i++
                                ) {
                                    if (
                                        content.ListVilles[i].CodePays ==
                                            $(
                                                J_AUTRES_PAYS_SELECT +
                                                    ' option:selected'
                                            ).data('value') ||
                                        $(
                                            J_AUTRES_PAYS_SELECT +
                                                ' option:selected'
                                        ).data('value') == 'FR'
                                    ) {
                                        const opt =
                                            document.createElement('option')
                                        opt.value =
                                            content.ListVilles[i].NomVilleReel
                                        opt.innerHTML =
                                            content.ListVilles[i].NomVille
                                        select[0].appendChild(opt)
                                    }
                                }

                                // On affiche la liste si elle est caché, et on cache le input classique s'il était affiché
                                if ($(select).hasClass(C_HIDDEN)) {
                                    bootstrapValidationForm.default.disableValidator(
                                        $(form),
                                        J_VILLE_NAME,
                                        'notEmpty'
                                    ) // on désactive également le validateur noEmpty, pour qu'on puisse appuyer sur le bouton submit si on choisit une ville
                                    $(select).removeClass(C_HIDDEN)
                                    $(J_CLASSICAL_VILLE_INPUT).addClass(
                                        C_HIDDEN
                                    )
                                }
                            } else if (content.ListVilles.length === 0) {
                                if ($(select).hasClass(C_HIDDEN) === false) {
                                    $(select).addClass(C_HIDDEN)
                                }
                                if (
                                    $(J_CLASSICAL_VILLE_INPUT).hasClass(
                                        C_HIDDEN
                                    )
                                ) {
                                    $(J_CLASSICAL_VILLE_INPUT).removeClass(
                                        C_HIDDEN
                                    )
                                }
                            }
                        },
                        function () {
                            // En cas d'échec on affiche une erreur
                            const $location = $(J_DIV_ERROR_CODE_POSTAL)
                            $location.removeClass(C_HIDDEN)
                            $location
                                .empty()
                                .append($t('ERREUR_INTERNE_RECUPERATION_VILLE'))
                        },
                        action
                    )
                }
            }
        )
    })
}

/*
 * Fonction qui sera passé en callback du module autoComplete : elle récupère la liste des villes qui commencent par la valeur de l'input passé en paramètre de cette fonction
 */
function getListOfVillesForAutoCompleteField($item) {
    return function findMatches(q, callback) {
        const action = $item.data(J_SOURCE_AJAX_DATA)

        // q = valeur de l'input
        const parameters = {
            name: q
        }

        ajaxLoader.loadAndExecuteCallBack(
            'POST',
            parameters,
            function (content) {
                const matches = []
                for (let i = 0; i < content.ListVilles.length; i++) {
                    matches.push({
                        value: content.ListVilles[i].Value,
                        cp: content.ListVilles[i].Key
                    })
                }

                callback(matches)
            },
            function () {
                const $location = $(J_VILLE_ERROR)
                $location.removeClass(C_HIDDEN)
                $location
                    .empty()
                    .append($t('ERREUR_INTERNE_RECUPERATION_VILLE'))
            },
            action
        )
    }
}

/*
 * Insert le CP dans le champ CP quand on sélectionne une ville et change le pays (envoyé en callback de l'autocomplete)
 */
function insertCodePostalWhenSelectingVille(event, item) {
    import('Modules/bootstrapValidationForm').then(
        (bootstrapValidationForm) => {
            $(J_CODE_POSTAL).val(item.cp)
            $(J_CODE_POSTAL).empty().append(item.cp)
            const formId = $(J_CODE_POSTAL).closest('form').attr('id')
            if (formId !== undefined) {
                bootstrapValidationForm.default.setItemAsValid(
                    '#' + formId,
                    $(J_CODE_POSTAL),
                    'notEmpty'
                )
                bootstrapValidationForm.default.validateField(
                    '#' + formId,
                    $(J_CODE_POSTAL)
                )
            }

            $(
                J_AUTRES_PAYS_SELECT +
                    ' option[data-value="' +
                    item.value.substr(item.value.length - 2) +
                    '"]'
            ).prop('selected', true)
            $(J_LABEL_PAYS_TO_HIDE).text($(J_AUTRES_PAYS_SELECT).val())
            $(J_LABEL_PAYS_TO_HIDE).removeClass(C_HIDDEN)
            $(J_AUTRES_PAYS_SELECT).addClass(C_HIDDEN)
        }
    )
}

/*
 * Function de gestion du clique sur "Autres pays" qui va afficher la liste select et cacher le label FRANCE
 */
function setEventForPrintingOtherPays() {
    $(J_AUTRES_PAYS_LINK).on('click', function (event) {
        const $select = $(J_AUTRES_PAYS_SELECT)

        if ($select !== undefined && $select !== '') {
            if ($select.hasClass(C_HIDDEN)) {
                $select.removeClass(C_HIDDEN)
                $(J_LABEL_PAYS_TO_HIDE).addClass(C_HIDDEN)
                $(event.currentTarget).addClass(C_HIDDEN)
            }
        }
    })
}

/*
 * Efface l'icone de validation si c'est une case téléphone, mais pas la dernière
 */
function removeTelephoneIcon(e, data) {
    if (
        $(data.element).hasClass(J_TELEPHONE.replace('.', '')) &&
        $(data.element).attr('name') !== J_LAST_TELEPHONE_NAME
    ) {
        // Remove the required icon when the field updates its status
        const $icon = $(
            ".icon-checkform-ok[data-bv-icon-for='" +
                $(data.element).attr('name') +
                "']"
        )
        $icon.addClass(C_HIDDEN)
    }
}

/*
 * Efface l'icone de validation des champs téléphone quand on tape
 * on affiche toujours l'icône invalide en priorité avec la première erreur
 */
function manageValidIconTelephone() {
    $(J_TELEPHONE).on('change paste keyup blur', function () {
        import('Modules/bootstrapValidationForm').then(
            (bootstrapValidationForm) => {
                const $telephone = $(J_TELEPHONE)
                const validTelephonList = []
                const invalidTelephonList = []
                let cptInvalidField = 0

                $telephone.each(function (index, item) {
                    if (
                        bootstrapValidationForm.default.isValidField(
                            $($(item).closest('form')),
                            $(item)
                        ) === true
                    ) {
                        validTelephonList.push(item)
                    }
                    if (
                        bootstrapValidationForm.default.isValidField(
                            $($(item).closest('form')),
                            $(item)
                        ) === false
                    ) {
                        cptInvalidField++
                        invalidTelephonList.push(item)
                    }
                })

                if (
                    cptInvalidField > 0 &&
                    validTelephonList !== undefined &&
                    validTelephonList.length > 0
                ) {
                    $(validTelephonList).each(function (index, item) {
                        if (
                            bootstrapValidationForm.isValidField(
                                $($(item).closest('form')),
                                $(item)
                            ) === true
                        ) {
                            const name = $(item).attr('name')
                            const icon = $(
                                ".icon-checkform-ok[data-bv-icon-for='" +
                                    name +
                                    "']"
                            )
                            if (icon !== undefined) {
                                $(icon).addClass(C_HIDDEN)
                            }
                        }
                    })
                }

                if (
                    cptInvalidField > 1 &&
                    invalidTelephonList !== undefined &&
                    invalidTelephonList.length > 1
                ) {
                    // on efface le premier élément pour afficher une erreur à la fois. Si son erreur est à hidden, on l'affiche
                    const firstElement = invalidTelephonList.shift()
                    let name = $(firstElement).attr('name')
                    let error = $(".help-block[data-bv-for='" + name + "']")
                    if (error !== undefined && $(error).hasClass(C_HIDDEN)) {
                        $(error).removeClass(C_HIDDEN)
                    }

                    // On cache les autres erreurs
                    $(invalidTelephonList).each(function (index, item) {
                        if (
                            bootstrapValidationForm.default.isValidField(
                                $($(item).closest('form')),
                                $(item)
                            ) === false
                        ) {
                            name = $(item).attr('name')
                            error = $(".help-block[data-bv-for='" + name + "']")
                            if (error !== undefined) {
                                $(error).addClass(C_HIDDEN)
                            }
                        }
                    })
                } else {
                    // Si il n'y a qu'une erreur et qu'elle est caché, on l'affiche
                    const name = $(invalidTelephonList[0]).attr('name')
                    const error = $(".help-block[data-bv-for='" + name + "']")
                    if (error !== undefined && $(error).hasClass(C_HIDDEN)) {
                        $(error).removeClass(C_HIDDEN)
                    }
                }
            }
        )
    })
}

/*
 * selon le pays actuellement sélectionné, on change les settings du formulaire / affiche des choses différentes
 */
function changeSettingsByPays() {
    $(J_AUTRES_PAYS_SELECT).on('change', function (event) {
        import('Modules/bootstrapValidationForm').then(
            (bootstrapValidationForm) => {
                // produit.default.init('#modal-produit', '#modal-produit-dialog')
                const form = $(event.currentTarget).closest('form')

                // raz des champ CP et Ville
                $(J_VILLE_SELECTOR).val('')
                $(J_CLASSICAL_VILLE_INPUT).val('')
                $(J_CODE_POSTAL).val('')

                if (
                    $(event.currentTarget)
                        .find(':selected')
                        .data(J_DATA_VALUE_PAYS) === 'FR'
                ) {
                    // Changement du field telephone
                    $(J_TELEPHONE).removeClass(C_HIDDEN)
                    $(J_OTHER_TELEPHONE).addClass(C_HIDDEN)

                    // Changement des settings du code postal
                    bootstrapValidationForm.default.enableValidator(
                        '#' + $(form).attr('id'),
                        J_CODE_POSTAL_NAME,
                        'stringLength'
                    )
                    bootstrapValidationForm.default.validateField(
                        '#' + $(form).attr('id'),
                        J_CODE_POSTAL_NAME
                    )
                } else {
                    // Changement du field telephone
                    $(J_OTHER_TELEPHONE).removeClass(C_HIDDEN)
                    $(J_TELEPHONE).addClass(C_HIDDEN)

                    $(J_VILLE_SELECTOR).addClass(C_HIDDEN)
                    $(J_CLASSICAL_VILLE_INPUT).removeClass(C_HIDDEN)

                    // Changement des settings du code postal
                    bootstrapValidationForm.default.disableValidator(
                        '#' + $(form).attr('id'),
                        J_CODE_POSTAL_NAME,
                        'stringLength'
                    )
                    bootstrapValidationForm.default.validateField(
                        '#' + $(form).attr('id'),
                        J_CODE_POSTAL_NAME
                    )
                }
            }
        )
    })
}

function showVilleFieldWhenSelectingAutresVilles() {
    $(J_VILLE_SELECTOR).on('change', function (event) {
        if ($(event.currentTarget).val() === J_AUTRES_VILLES) {
            if ($(event.currentTarget).hasClass(C_HIDDEN) === false) {
                $(event.currentTarget).addClass(C_HIDDEN)
            }
            if ($(J_CLASSICAL_VILLE_INPUT).hasClass(C_HIDDEN)) {
                $(J_CLASSICAL_VILLE_INPUT).removeClass(C_HIDDEN)
            }
            // $(J_AUTRES_PAYS_SELECT + ' option[data-value=FR]').remove();
            $(J_AUTRES_PAYS_SELECT).removeClass(C_HIDDEN)
            $(J_LABEL_PAYS_TO_HIDE).addClass(C_HIDDEN)
        } else {
            const cityName = $(event.currentTarget).val()
            // Modification du pays lors de la sélection d'une ville depuis la combobox autocomplétante
            if (cityName.substring(cityName.length - 2) == 'FR') {
                // var opt = document.createElement("option");
                // opt.text = "France Metropolitaine";
                // opt.setAttribute('data-value', 'FR');
                // $(J_AUTRES_PAYS_SELECT).children('optgroup')[0].appendChild(opt);
            } else {
                // $(J_AUTRES_PAYS_SELECT + ' option[data-value=FR]').remove();
            }

            $(J_CLASSICAL_VILLE_INPUT).val(cityName)

            // $(J_AUTRES_PAYS_SELECT + ' option').prop('selected', false);
            // $(J_AUTRES_PAYS_SELECT + ' option[data-value="' + cityName.substring(cityName.length - 2) + '"]').prop('selected', true);
            // $(J_LABEL_PAYS_TO_HIDE).removeClass(C_HIDDEN);
            // $(J_LABEL_PAYS_TO_HIDE).text($(J_AUTRES_PAYS_SELECT).val());
            // $(J_AUTRES_PAYS_SELECT).addClass(C_HIDDEN);
        }
    })
}

export default {
    processModificationAdresseLivraison: processModificationAdresseLivraison,
    processModificationAdresseFacturation:
        processModificationAdresseFacturation,
    setEventOnComplementAdresseLink: setEventOnComplementAdresseLink,
    setEventForGettingVillesByCodePostal: setEventForGettingVillesByCodePostal,
    getListOfVillesForAutoCompleteField: getListOfVillesForAutoCompleteField,
    insertCodePostalWhenSelectingVille: insertCodePostalWhenSelectingVille,
    setEventForPrintingOtherPays: setEventForPrintingOtherPays,
    manageValidIconTelephone: manageValidIconTelephone,
    removeTelephoneIcon: removeTelephoneIcon,
    changeSettingsByPays: changeSettingsByPays,
    showVilleFieldWhenSelectingAutresVilles:
        showVilleFieldWhenSelectingAutresVilles
}
